import { Component, DoCheck, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { UserInfo } from '../../modules/buildings-shared/model/user-info';
import { SharedUtils } from '../../modules/buildings-shared/utilities/shared-utils';

@Component({
  selector: 'app-password-forgot-complete',
  imports: [RouterLinkActive, RouterLink],
  templateUrl: './password-forgot-complete.component.html',
  styleUrl: './password-forgot-complete.component.scss'
})
export class PasswordForgotCompleteComponent implements OnInit {

    emailSent: WritableSignal<boolean | undefined> = signal<boolean | undefined>(undefined);
    userEmail: WritableSignal<string | undefined> = signal<string | undefined>(undefined);
    sendingMailSuspended: WritableSignal<boolean> = signal<boolean>(false);

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private permissionService: PermissionService) {}

    ngOnInit(): void {
        this.permissionService.setWaitingSpinner(true);
        this.sendingMailSuspended.set(true);
        this.activatedRoute.params.subscribe( (params) => {
            this.emailSent.set(params['success']);
            this.userEmail.set(params['email']);
            this.permissionService.setWaitingSpinner(false);
            setTimeout( () => this.sendingMailSuspended.set(false), 30000);
        });
    }

    sendNewEmail() {
        this.permissionService.setWaitingSpinner(true);
        if (this.userEmail() && (this.userEmail()?.length ?? 0) > 0 && !this.sendingMailSuspended()) {
            let modalMessage: string = "";

            this.permissionService.forgotPassword(this.userEmail() as string).then( (result: boolean) => {
                modalMessage = (!!result) ? ("Abbiamo inviato una nuova mail all'indirizzo di posta \"" + this.userEmail() + "\".") : "Non è stato possibile inviare nuovamente la mail: riprova più tardi." 
            }).catch((error: any) => {
                console.error("PasswordForgotCompleteComponent.sendNewMail() - An error occurred. ERROR: " + JSON.stringify(error));
                modalMessage =  "Non è stato possibile inviare nuovamente la mail: riprova più tardi.";
            }).finally(() => {
                this.permissionService.setWaitingSpinner(false);
                this.permissionService.alert( modalMessage ).then( () => {
                    this.sendingMailSuspended.set(true);
                    setTimeout( () => this.sendingMailSuspended.set(false), 60000);
                });
            });
        } else {
            this.permissionService.setWaitingSpinner(false);
        }
    }
}